import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { deleteTimesheet, updateTimesheet } from '../../../store/actions/timesheetAction'
import { IconButton } from '@mui/material';
import { DeleteRounded, EditRounded } from '@mui/icons-material';
import { AppointmentTooltip } from '@devexpress/dx-react-scheduler-material-ui';
import TimeSheetForm from '../../EmployeeView/TimeSheet/TimeSheetForm';

class AppointmentHeader extends Component {
    state = {
        openUpdate : false
    }
    deleteTimesheet = () => {
       this.props.deleteTimesheet(this.props.appointmentData.timesheet_id)
    }
    updateTimesheet = () => {
        console.log("IN OPEN UPDATE");
        this.setState({
            openUpdate: true
        })
    }
    render() {
        const { children, appointmentData, classes, ...restProps } = this.props
        const { openUpdate } = this.state;
        return (
            <AppointmentTooltip.Header
                {...restProps}
                appointmentData={appointmentData}
            >
                {openUpdate &&
                    <TimeSheetForm
                        {...this.props}
                        timesheet={appointmentData}
                        update
                        handleClose={() => this.setState({ openUpdate: false})}
                    />
                }
                <IconButton color="primary" onClick={this.updateTimesheet} size="large">
                    <EditRounded />
                </IconButton>
                <IconButton onClick={this.deleteTimesheet} size="large">
                    <DeleteRounded color="error" />
                </IconButton>
            </AppointmentTooltip.Header>
        );

    }
}
const mapStateToProps = (state) => {
    return {
        TIMESHEETS: state.timesheets,
        PROJECTS: state.projects,
        STATE: state.request,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
        deleteTimesheet,
        updateTimesheet,
    }
, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentHeader);